
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import App from "./containers/App";
import Login from "./containers/Login";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter, Route,Switch } from "react-router-dom";
import Maintenance from "./containers/Maintenance";


ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Switch>
                <Route exact path ="/pa" component={Login} />
                <Route exact path="/pa/maintenance" component={Maintenance} />
                <Route path="/pa/app" component={App} />
            </Switch>
        </BrowserRouter>

    </Provider>, document.getElementById("root"));


serviceWorker.unregister();

window.store = store;
